import { useInfiniteQuery } from "@tanstack/react-query"

import { getPurchasedWebinars } from "../functions"
import { UserQueryKey, GetInfinitePurchasedWebinarsParams } from "../../types"

const useInfiniteGetPurchasedWebinars = (
  params?: GetInfinitePurchasedWebinarsParams
) => {
  return useInfiniteQuery({
    queryKey: [UserQueryKey.PurchasedWebinar, params?.qParams ?? {}],
    queryFn: ({ pageParam }) =>
      getPurchasedWebinars({ ...params?.qParams, page: pageParam }),
    getNextPageParam: (lastPage) => {
      if (!lastPage.meta) return

      const isLastPage = lastPage.meta.current_page === lastPage.meta?.last_page
      if (isLastPage) return

      return lastPage.meta.current_page + 1
    },
    ...params?.options,
  })
}

export default useInfiniteGetPurchasedWebinars
